$(function(){

   $('.pricing-content-wrapper .pricing-content').on('click', function(e){
      e.preventDefault();

      $(this).addClass('active').siblings().removeClass('active');

   });

   $('.subscription-price-options .btn').on('click', function(e){
       e.preventDefault();

       const currentBtn = $(this);
       const subscriptionType = currentBtn.data('subscriptiontype');

       currentBtn.addClass('btn-primary').removeClass('btn-outline-primary');
       currentBtn.siblings().removeClass('btn-primary').addClass('btn-outline-primary');

       $(`.pricing-content .${subscriptionType}Subscription`).show().siblings().hide();
       $('.subscription-features').hide();
       $(`#features-${subscriptionType}`).show();

   });

    $('#signUpSchool').on('click', function (e) {

        e.preventDefault();

        const schoolType = $('.pricing-content.active').data('schooltypeid');
        const subscriptionType = $('.btn-primary.subscriptionBtn').data('subscriptiontype');
        const userSelectedPlan = {'school_type': schoolType, 'subscription_type': subscriptionType};

        Cookies.set('user_selected_plan', JSON.stringify(userSelectedPlan), {
            path: '/',
            domain: DOMAIN_NAME,
            expires: 7
        });

        $(this).text('wait...').prop('disabled', true);
        window.location.href = $(this).attr('href');

    });

    $("#payNow").on('click', function (e) {
        rzp1.open();
    });

    window.CapturePayment = (paymentId) => {
        mainApiAxios.post('/capture-payment',{razorpay_payment_id:paymentId}).then(res=>{
            window.location.reload();
        }).catch(err=>{
            console.log(err);
        });
    }

});

